export { MOCK_HEADER_DATA } from './lib/constants/mock-menu-data';
export * from './lib/header';